import React, { Component } from 'react';
import { connect } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import Button from 'screens/components/basic/Button';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import WithRouter from 'custom/withRouter';
import { getCampaignDb } from 'actions/DashboardActions';

class DbOrders extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;
        return (
            <div id="chart4" className="item col-4-p-0 mt-0">
                <DashDialog
                    text="Campaings"
                    isReport={true}
                    refreshAction={() => this.props.getCampaignDb(this.props.branchId)} />
                <div className="campaing_height">
                    {(props.campaings || []).length > 0 ?
                        this.props.loading
                            ?
                            <LinearProgress variant="indeterminate" />
                            :
                            <div>
                                {
                                    (props.campaings || []).map((item, index) => {
                                        return (
                                            <div className="campaing_box text-left" key={index}>
                                                <div className="mb-5">
                                                    <h2>{item.name}</h2>
                                                    <h2 className="green-text">${item.totalReceived}</h2>
                                                </div>
                                                <div className="row m-0">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 p-0">
                                                        <h5>Start Date</h5>
                                                        <p>{item.startDate}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 p-0">
                                                        <h5>End Date</h5>
                                                        <p>{item.endDate}</p>
                                                    </div>
                                                </div>
                                                {/* <div className="abs_t_b">
                                                <span>Active</span>
                                            </div> */}
                                            </div>
                                        )
                                    })
                                }
                            </div> :
                        <React.Fragment>
                            <h2 >NO CAMPAINGS TO DISPLAY</h2>
                            <Button
                                type="AddButton"
                                mini={true}
                                label="ADD NEW"
                                className="bg-light-green mt-5"
                                onTouchTap={() => this.props.navigate("/manage/campaign/add")}
                            />
                        </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.common.dbCampaingsCall > 0,
        branchId: state.common.branchId,
    }
}

function mapDispatchToProps(dispatch){
    return {
        getCampaignDb: (branchId) => dispatch(getCampaignDb(branchId, true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(DbOrders));
